<template>
<div class="grey--text">
    <div class="heading">{{element.title}}</div>
    <div class="calendar-day display-flex" v-for="day in upcomingDates" :key="day.date">
        <div>
            <span style="margin-right:15px;font-size:16px;font-weight:800;color:#bbb">{{day.weekday}}</span><br>
            {{day.shortDate}} <br>
        </div>
        <div>

            <div v-for="event in day.events" :key="event.key" class="mt-1 mr-1">
                <Flag primary>{{event.title}}</flag>
            </div>
            <div v-for="task in day.tasks" :key="task.key" class="mt-1 mr-1">
                <flag style="max-width:100%">{{task.title}} (task)</flag>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import OrderHelpers from '../helpers/OrderHelpers'
import Flag from '../ui-elements/Flag'
import { addDays, format } from 'date-fns'
import { dateFormats } from '../helpers/DateHelpers'
import DateHelpers from '../helpers/DateHelpers'


export default {
    data() {
        return {
        
        }
    },
    
    props: {
        element: Object,
    },

    components: {
        Flag
    },

    computed: {
        elements() {
            return this.$store.getters.elements
        },

        tabs() {
            return this.elements.filter(o => o.type && o.type == 'Tab').sort(OrderHelpers.sortAscending)
        },

        dateElements() {
            return this.elements.filter(o => o.type == 'Date')
        },

        nextTenDays() {
            let returnDates = []
            for(var i = 0; i < 10; i++) {
                //const dateMoment = Moment().add(i, 'days')
                const date = addDays(new Date(), i)

                //const dateStr = dateMoment.format('YYYY-MM-DD')
                const dateStr = format(date, dateFormats.BACKWARDS)

                let day = {
                    date: dateStr,
                    day: format(date, 'EEE')
                }
                returnDates.push(day)
            }
            return returnDates
        },

        upcomingDates() {
            let nextSevenDays = this.nextTenDays
            nextSevenDays.forEach(day => {
                day.weekday = day.day.toUpperCase() 
                day.shortDate = format(DateHelpers.backwardsToDate(day.date), 'd/M')
                let events = this.dateElements.filter(o => o.value == day.date)
                day.events = events
                let tasks = this.tasks.filter(o => o.due == day.date)
                day.tasks = tasks
            })
            return nextSevenDays
        },

        tasks() {
            return this.$store.getters.tasks.filter(o => o.transactionKey == this.element.transactionKey)
        },        
    },

    methods: {
        milestonesForTab(tabKey) {
            return this.milestones.filter(o => o.tabKey == tabKey)
        },

        complete(element) {
            element.value = true
            this.$emit('save', element)
        },

        notApplicable(element) {
            element.na = true
            this.$emit('save', element)
        }


    }
}
</script>

<style scoped>
.calendar-day {
    padding:10px;border-bottom:solid 1px #eee;
}
</style>




// WEBPACK FOOTER //
// ComingUp.vue?2e8d4ee6